<template>
  <qc-container :title="title">
    <page-request ref="table" url="/api/mgr/business/act/list" :table-header="tableHeader" :expend="expend" :prop="{goodsType:goodsType,type:searchActType}" :op-width="200">
      <div class="flex-cc full">
<!--        <el-tabs v-model="goodsType">
          <el-tab-pane label="线上商品" name="0"></el-tab-pane>
          <el-tab-pane label="门店商品" name="1"></el-tab-pane>
        </el-tabs>-->
        <div>
          <t-button @click="doAdd()">添加</t-button>
          <t-button @click="batchDel()">批量移除</t-button>
        </div>
      </div>
      <template #op="scope">
        <b-button @click="doDel([scope.row.id])">移除</b-button>
      </template>
    </page-request>
  </qc-container>

  <goods-select-all ref="goodsSelectAll" @change="addGoods"></goods-select-all>
</template>

<script>

import QcContainer from "@/components/el/layout/qc-container.vue";
import BButton from "@/components/el/b-button.vue";
import TButton from "@/components/el/t-button.vue";
import PageRequest from "@/components/base/page-request.vue";
import GoodsSelectAll from "@view/components/goods/goods-select-all.vue";

export default {
  props:{
    title:String,
    //搜索活动类型 0活动专区 1今日上新
    searchActType:{
      type:Number,
      default:0
    }
  },
  name: "act-list",
  components: {GoodsSelectAll, PageRequest, TButton, BButton, QcContainer},
  data() {
    return {
      goodsType:"0",
      tableHeader: [
        {type: "selection", label: ""},
        {type: "goodShop", label: "商品",minWidth:300},
        {label: "价格",renderDraw:row=>{
            let content = "";
            if(row.storeGoodsType===1 ){
              content = "租赁价格:￥"+row.marketPrice+"元";
            }else if(row.storeGoodsType===2){
              content = "出售价格:￥"+row.salesPrice+"元<br/>"+"租赁价格:￥"+row.marketPrice+"元"
            }else{
              content = "出售价格:￥"+row.salesPrice+"元";
            }
            return content + (row.isAttribute?"起":"");
          },width:220},
        {prop: "inventory", label: "库存",width:100,renderDraw:row=>{
            return row.inventory + (row.marketInventory||0);
          }},
        {label: "状态",renderDraw:row=>{
          if(this.goodsType==0){
            return row.goodsEnables==0?"下架":"在售";
          }else{
            if(row.goodsEnables==0){
              return "下架";
            }
            return row.enables?"在售":"下架";
          }
          },width: 100},
        {prop: "updateTime", label: "更新时间",width:160},
        {prop: "goodsCreateTime", label: "创建时间",width:160},
      ],
      expend: [
        {label: "商品名称", prop: "name"},
        {label: "商品ID", prop: "codes"},
        {label: "商品类型", prop:"storeGoodsType",type:"select",options:[{"label":"出售","value":"0"},{"label":"租赁","value":"1"},{"label":"出售+租赁","value":"2"},{"label":"洗消","value":"3"}]},
        {label: "创建时间", start: "createTimeStart", end: "createTimeEnd", type: "daterange"}
      ],
    }
  },
  mixins: [tableBase],
  methods: {
    addGoods(list){
      let actGoodsList = list.map(item=>{
        if(this.goodsType==0){//线上
          return {
            goodsId:item.id,
            shopId:item.orgId
          }
        }else{
          return {
            goodsId:item.goodsId,
            shopId:item.shopId
          }
        }
      });
      if(actGoodsList.length==0){
        this.messageError("请选择商品");
        return;
      }
      this.simplePost("/api/mgr/business/act/add", {addGoodsList:actGoodsList,type:this.searchActType,goodsType:this.goodsType,contentType:_CONTENT_TYPE_JSON}, () => {
        this.pageReloadData();
      })
    },
    doAdd() {
      this.$refs.goodsSelectAll.open(this.goodsType);
    },
    doDel(ids) {
      this.msgConfirm("/api/mgr/business/act/delete", {ids: ids}, () => {
        this.pageReloadData();
      },"您是否确定移除所选商品?");
    },
    batchDel(){
      let list = this.$refs.table.getSelectionRows();
      if(list&&list.length>0){
        let ids = list.map(item=>item.id);
        this.doDel(ids);
      }else{
        this.messageError("请勾选要操作的对象");
      }
    }
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
